import { IdentityVerificationDialog } from './identity-verification-dialog'

import { EObjectiveType } from '~/core/enums'
import { GuildApi } from '~/services/fm/guild'

export const UserPermissionVerificationDialog = ({
  type = EObjectiveType.ImportantOperation,
  ...props
}: {
  open: boolean
  type?: EObjectiveType

  onSubmit: () => Promise<void>
  onClose: () => void
}) => {
  const [triggerSetUserPermission] = GuildApi.setUserPermission.useMutation()

  return (
    <IdentityVerificationDialog
      open={props.open}
      onSubmit={async (code) => {
        const { state, info } = await triggerSetUserPermission({
          identify_code: code,
          objective_type: type,
        }).unwrap()

        if (state === 'fail') {
          return {
            success: false,
            message: info,
          }
        }

        await props.onSubmit()
        return { success: true }
      }}
      onClose={props.onClose}
    />
  )
}
